import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import AppInput from '../../common/AppInput';
import ReCAPTCHA from '../../common/ReCaptcha';
import LoadingButton from '../../common/LoadingButton';
import MotiveTitle from '../../views/Contact/Motive/MotiveTitle';
import { RADIO_OPTIONS, PREFORM_FIELDS } from './validation/fields';
import { usePreFormGiftcard } from './styles';
import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import { textMapper } from '../../../helpers/FormHelper';
import {
  setGiftCardNumber,
  setProblemsGiftcard,
} from '../../../redux/slices/IssuesSlice';
import { setIsValidReCaptcha } from '../../../redux/slices/reCaptchaSlice';
import { setAuthorized } from '../../../redux/slices/RoutesAuthSlice';
import { SELECT_PROBLEM_GIFTCARD } from '../../../constants/texts';
import { schema } from './validation/schema';

const Form = ({ ...props }) => {
  const { state, onData, mobile, valid, motiveId } = props;
  const classes = usePreFormGiftcard({ mobile });
  const history = useHistory();
  const [valueRadioOptions, setValueRadioOptions] = useState('');
  const dispatch = useDispatch();
  const { reCaptchaToken, isValidReCaptcha } = useSelector(
    (state) => state.reCaptchaSlice,
  );
  const [showOcCaptcha, setShowOcCaptcha] = useState(false);

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
    dispatch(setGiftCardNumber(e.target.value));

    let fieldsValidate = schema.validate({ [e.target.name]: e.target.value });
    if ('error' in fieldsValidate) {
      setShowOcCaptcha(false);
      resetCaptcha();
    } else setShowOcCaptcha(true);
  };

  const resetCaptcha = () => {
    dispatch(setIsValidReCaptcha(false));
  };

  const onChangeRadio = (e) => {
    setValueRadioOptions(e.target.value);
    dispatch(setProblemsGiftcard(e.target.value));
  };

  const onClick = () => {
    dispatch(setAuthorized(true));
    history.push(textMapper.get(motiveId).redirect);
  };

  return (
    <React.Fragment>
      {mobile && (
        <MotiveTitle
          icon={textMapper.get(motiveId).icon}
          title={textMapper.get(motiveId).title}
          subtitle={textMapper.get(motiveId).subtitle}
          mobile={mobile}
        />
      )}
      <Typography className={classes.title}>
        {SELECT_PROBLEM_GIFTCARD}
      </Typography>
      <RadioGroup onChange={onChangeRadio} value={valueRadioOptions}>
        {RADIO_OPTIONS.map((field, index) => (
          <FormControlLabel
            key={index}
            control={
              <Radio
                color="primary"
                data-cy={`radio${field.value.split(' ').join('')}`}
              />
            }
            label={field.value}
            value={field.value}
          />
        ))}
        {PREFORM_FIELDS.map((field, index) => (
          <AppInput
            key={index}
            onChange={handleChange}
            onBlur={() => {}}
            onClick={() => {}}
            disabled={state[field.name]?.disabled || false}
            name={field.name}
            error={state[field.name]?.error || false}
            type={state[field.name]?.type || ''}
            label={state[field.name]?.label || ''}
            required={state[field.name]?.required || false}
            inputAdornment={state[field.name]?.inputAdornment || ''}
            success={state[field.name]?.success || ''}
            helperText={state[field.name]?.helper || ''}
            multiline={state[field.name]?.multiline || false}
            rows={state[field.name]?.rows || ''}
            value={state[field.name]?.value || ''}
            errorMessage={state[field.name]?.message || ''}
          />
        ))}
        {showOcCaptcha && (
          <React.Fragment>
            <ReCAPTCHA />
            <LoadingButton
              className={classes.button}
              onClick={onClick}
              name="PreFormGiftcardProblems"
              variant="contained"
              color="primary"
              text="Continuar"
              disabled={
                !valid ||
                valueRadioOptions.length === 0 ||
                !isValidReCaptcha ||
                reCaptchaToken.length === 0
              }
            />
          </React.Fragment>
        )}
      </RadioGroup>
    </React.Fragment>
    // eslint-disable-next-line
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  valid: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default Form;
